import React, { useState, useContext } from 'react';
import { FormContext } from '../../FormContext';
import axios from 'axios'
import './FileUpload.css'
import { isFieldSigned } from './utils.js';
import InputAddRemove from './InputAddRemove';

const FileUpload = ({ field_filename, field_multiple_primary, field_column, field_label, field_id, field_value, field_disabled, field_mandatory, field_multiple, field_disabled_approver, field_multiple_id, field_multiple_type }) => {
  const { handleChangeInput, submitId, id, handleAddField, formStatus, handleRemoveLastField, formPageType, formApprovalIndex, formUserLock, formChatPerson, formOfficers, formMultipleType } = useContext(FormContext);

  const [uploadPercentage, setUploadPercentage] = useState(0);
  const [uploadSuccess, setUploadedSuccess] = useState(false);
  const [tmpFile, setTmpFile] = useState(null);

  const path = (submitId && !tmpFile) ? `https://eform.hsu.edu.hk/file.php?id=form/${id}/${submitId}/${field_value}` : `https://eform.hsu.edu.hk/file.php?id=temporary/${tmpFile}`;

  let isSigned = isFieldSigned(field_id, formMultipleType, formChatPerson, formOfficers, field_multiple_type);
  let allowEditFileByOfficer = formOfficers.includes(formChatPerson) && formPageType=="user";

  const removeFile = e => {
    handleChangeInput(field_id, e, '');
    setUploadedSuccess(false);
    setTmpFile(null);
  };

  const onSubmit = async e => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('file', e.target.files[0]);
    
    try {
      const res = await axios.post('https://eform.hsu.edu.hk/api/public/uploadTemp/index.php', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      
      const { data } = res;
      if (data !== 0) {
        setUploadedSuccess(true);
        setTmpFile(data);
        handleChangeInput(field_id, e, data);
      } else {
        setUploadedSuccess(false);
        alert('File upload error');
      }
    } catch (error) {
      setUploadedSuccess(false);
      alert('There is an error in uploading the file');
    }
  };

  let isDisabled;
  if (formUserLock && formPageType === 'user') {
    isDisabled = true;
  } else if (formPageType === 'user') {
    if (field_multiple_id === 'mapprover') {
      isDisabled = true || (
        (field_id.startsWith('user_approver_') ||
          field_id.startsWith('user_action_')) &&
        parseInt(field_id.slice(-1)) < formApprovalIndex);
    } else {
      isDisabled = true;
    }
  } else {
    isDisabled =
      field_disabled_approver === '1' ||
      field_disabled ||
      isSigned ||
      (formStatus === 'Submitted' &&
        (field_multiple_id === 'mapprover' ||
          field_id.startsWith('user_approver_')));
  }

  if (allowEditFileByOfficer) {
    isDisabled = false;
  }

  const renderUpload = (
    <>
      {(uploadSuccess || field_value) && (
        <div className="mb-3">
          <span className="file-label">File: {field_filename}&nbsp;&nbsp;</span>
          <a 
            target="_blank" 
            className="text-success" 
            onClick={() => window.open(path, "_blank")}
          >
            <u>Download</u>
          </a>
          {(formPageType !== 'user' || allowEditFileByOfficer) && (
            <a 
              className="text-danger pl-3" 
              onClick={removeFile}
            >
              <u>Remove</u>
            </a>
          )}
        </div>
      )}

      {!isDisabled && (
        <input
          type="file"
          className="form-control form-input"
          name="field_value"
          autoComplete="off"
          accept=".xlsx,.xls,image/*,.doc,.docx,.ppt,.pptx,.txt,.pdf,.zip"
          style={{ height: 'calc(2.75rem)' }}
          onChange={(event) => {
            const file = event.target.files[0];
            if (!file) return;
            
            const fileName = file.name;
            const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();

            if (fileExtension !== 'heic') {
              onSubmit(event);
            } else {
              alert('HEIC is not allowed. Please upload JPG/PNG format.');
              event.target.value = '';
            }
          }}
        />
      )}

      <input type="hidden" className="form-control form-input" />

      {!formUserLock && <InputAddRemove field_id={field_id} field_multiple_id={field_multiple_id} />}
    </>
  );

  return (
    <div className={`form-group ${field_column || 'col-sm-12'}`}>
      <label>
        {field_label} <font color="red">{field_mandatory === 'yes' ? '*' : ''}</font>
      </label>
      {renderUpload}
    </div>
  );
};

export default FileUpload;